export default __webpack_public_path__ + "static/Quickswap-8e7b2969f629752e37a631fadca47f65.svg";